import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Award, Printer, ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function Certificate() {
  const { id } = useParams();
  const { data, isLoading, isError } = useQuery({ queryKey: ["certificate", id], queryFn: () => api.get(`/courses/${id}/certificate`).then((r) => r.data), retry: false });

  if (isLoading) return <div className="min-h-[60vh] grid place-items-center"><Loader2 className="animate-spin text-[#144F75]" size={30} /></div>;
  if (isError || !data) return <div className="min-h-[60vh] grid place-items-center text-[#4A5D6B]">Complete the course to unlock your certificate. <Link to={`/courses/${id}`} className="text-[#144F75] underline ml-1">Back to course</Link></div>;

  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="certificate-page">
      <div className="flex items-center justify-between mb-6 print:hidden">
        <Link to="/my-learning" className="text-sm text-[#4A5D6B] hover:text-[#144F75] flex items-center gap-1"><ArrowLeft size={15} /> My Learning</Link>
        <button onClick={() => window.print()} data-testid="cert-print" className="eyw-btn-outline !py-2 text-sm"><Printer size={15} /> Print</button>
      </div>
      <div className="flex justify-end mb-4 print:hidden">
        <button data-testid="cert-download-pdf" className="eyw-btn !py-2 text-sm"
          onClick={async () => {
            const r = await api.get(`/courses/${id}/certificate.pdf`, { responseType: "blob" });
            const url = URL.createObjectURL(r.data);
            const a = document.createElement("a");
            a.href = url; a.download = "certificate.pdf"; a.click();
            URL.revokeObjectURL(url);
          }}><Award size={15} /> Download PDF</button>
      </div>

      <div className="rounded-2xl border-4 border-[#144F75] bg-white p-12 text-center shadow-xl" data-testid="certificate-card">
        <Award className="mx-auto text-[#D98E73] mb-4" size={48} />
        <p className="eyw-label !text-[#D98E73] tracking-[0.25em]">Certificate of Completion</p>
        <p className="text-[#4A5D6B] text-sm mt-6">This certifies that</p>
        <h1 className="font-serif text-4xl text-[#1A242B] mt-2">{data.learner_name}</h1>
        <p className="text-[#4A5D6B] text-sm mt-4">has successfully completed the course</p>
        <h2 className="font-serif text-2xl text-[#144F75] mt-2">{data.course_title}</h2>
        <p className="text-[#4A5D6B] mt-3">with {data.enhancer_name} · Enhancing Your World</p>
        <div className="mt-10 flex items-center justify-center gap-16">
          <div className="text-center">
            <p className="font-serif text-lg text-[#1A242B] border-b border-[#E5E0D8] pb-1 px-6">{(data.completed_at || "").slice(0, 10)}</p>
            <p className="text-xs text-[#8FA89B] mt-1">Date completed</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-lg text-[#1A242B] border-b border-[#E5E0D8] pb-1 px-6">Enhancing Your World</p>
            <p className="text-xs text-[#8FA89B] mt-1">Issued by</p>
          </div>
        </div>
      </div>
    </div>
  );
}
